<template>
    <div>
        <div class="ecran bloc col-lg-12">
            <h5>Sollicitation de stationner un véhicule</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Immatriculation 1: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.stationnement_immatriculation_1"></b-input></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Immatriculation 2: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.stationnement_immatriculation_2"></b-input></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Immatriculation 3: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.stationnement_immatriculation_3"></b-input></b-col>
                </b-row>
            </div>
        </div>

        <div class="ecran bloc col-lg-12">
            <h5>Dates</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Date de début: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6">
                        <b-form-datepicker hide-header :start-weekday="1" v-model="date_deb" :disabled="isDisabled && isHourDisabled" placeholder="Date de début" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                    </b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Date de fin (incluse): </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6">
                        <b-form-datepicker hide-header :start-weekday="1" v-model="date_fin" :disabled="isDisabled && isHourDisabled" placeholder="Date de fin" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="ecran bloc col-lg-12">
            <h5>Motif</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Motif de la demande: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-textarea :disabled="isDisabled" v-model="request.stationnement_motif_demande"></b-textarea></b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuex from "vuex";

    export default {
        name: "Stationnement",
        async mounted() {
            if(this.request.id == null && this.id != null)
                await this.getDemande({layername: 'odp_stationnement', id: this.id});
        },
        props: ["id"],
        computed: {
            request: {
                get() {
                    return this.currentDemande;
                },
                set(value) {
                    this.setDemande(value);
                }
            },
            date_deb: {
                get() {
                    if(this.request.date_deb.indexOf('/') > -1)
                        return this.formatDate(this.request, 'date_deb')
                    else
                        return this.request.date_deb;
                },
                set(value) {
                    this.request.date_deb = value;
                }
            },
            date_fin: {
                get() {
                    if(this.request.date_fin.indexOf('/') > -1)
                        return this.formatDate(this.request, 'date_fin')
                    else
                        return this.request.date_fin;
                },
                set(value) {
                    this.request.date_fin = value;
                }
            },
            ...Vuex.mapGetters('Demande', ['currentDemande']),
            ...Vuex.mapGetters('Application', ['isHourDisabled', 'isDisabled'])
        },
        methods: {
            formatDetails(value) {
                return !!parseInt(value);
            },
            formatDate(value, row) {
                if(typeof value === 'undefined')
                    return "";
                else {
                    let date;
                    if(row == 'date_deb')
                        date = value.date_deb.split('/');
                    else if (row == 'date_fin')
                        date = value.date_fin.split('/');

                    date = date[2] + '-' + date[1] + '-' + date[0];
                    // console.log(date);
                    return date;
                }
            },
            ...Vuex.mapActions('Demande', ['getDemande', "setDemande"])
        }
    }
</script>

<style scoped>

</style>